module.exports = __webpack_public_path__ + "static/60-3f189b52dce5b0c2bcc9aed55f7d201e.png";